import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getOnBoardingByKey,
  getOnBoardingInfoById,
  getOnBoardingQuestionById,
  getOnBoardingReviews,
} from '../../api/onboarding';
import { RootState } from '../index';

export const fetchOnBoarding = createAsyncThunk('onBoarding/fetch', async (id: string) => {
  const response = await getOnBoardingByKey(id);
  return response;
});

export const fetchOnBoardingQuestion = createAsyncThunk('onBoardingQuestion/fetch', async (id: string) => {
  const response = await getOnBoardingQuestionById(id);
  return response;
});

export const fetchOnBoardingInfo = createAsyncThunk('onBoardingInfo/fetch', async (id: string) => {
  const response = await getOnBoardingInfoById(id);
  return response;
});

export const fetchOnBoardingReviews = createAsyncThunk('onBoardingReviews/fetch', async (locale: string, thunkAPI) => {
  const {
    onBoarding: {
      reviews: { limit, offset },
    },
  } = thunkAPI.getState() as RootState;
  const response = await getOnBoardingReviews(limit, offset, locale);
  return response;
});
